import React from 'react';
import { Col, Row } from 'reactstrap';
import Administrator from './Administrator';
import BrowserStatus from './BrowserStatus';

const AdministratorBrowser = () => {
  return (
    <Col md='6' xl='4' lg='6' className='box-col-4 xl-40'>
      <Row>
        <Administrator />
        <BrowserStatus />
      </Row>
    </Col>
  );
};

export default AdministratorBrowser;
